var map = {
	"./QuickSwap_logo.png": 1769,
	"./USDT.png": 1770,
	"./apecoin.png": 443,
	"./arkane.svg": 1771,
	"./arrow-down-blue.svg": 1772,
	"./arrow-down-grey.svg": 1773,
	"./arrow-right-white.png": 1774,
	"./arrow-right.svg": 1775,
	"./arrowright.svg": 1776,
	"./big_unicorn.png": 1777,
	"./blue-loader.svg": 111,
	"./circle-grey.svg": 1778,
	"./circle.svg": 1779,
	"./coinbaseWalletIcon.svg": 1780,
	"./dropdown-blue.svg": 1781,
	"./dropdown.svg": 1782,
	"./dropup-blue.svg": 1783,
	"./ethereum-logo.png": 1784,
	"./fortmaticIcon.png": 241,
	"./gnosis_safe.png": 1785,
	"./link.svg": 1786,
	"./logo.png": 1787,
	"./logo_circle.png": 445,
	"./magnifying-glass.svg": 1788,
	"./matic.png": 1789,
	"./menu.svg": 1790,
	"./metamask.png": 444,
	"./noise.png": 240,
	"./plus-blue.svg": 1791,
	"./plus-grey.svg": 1792,
	"./portisIcon.png": 242,
	"./qsbg.png": 238,
	"./question-mark.svg": 1793,
	"./question.svg": 1794,
	"./quick_logo.jpeg": 179,
	"./spinner.svg": 1795,
	"./swap.svg": 1796,
	"./token-list/lists-dark.png": 1797,
	"./token-list/lists-light.png": 1798,
	"./token-logo.png": 1799,
	"./trustWallet.png": 1800,
	"./venly.svg": 1801,
	"./walletConnectIcon.svg": 243,
	"./x.svg": 1802,
	"./xl_uni.png": 239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 431;